<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Subscriptions </v-toolbar-title>
    </v-toolbar>
    <v-card-actions v-if="!tenant_uid">
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="startDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="From"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="startDate"
                  show-adjacent-months
                  :max="endDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div>
        <v-menu :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-bind="attrs"
              v-on="on"
              dense
              outlined
              :value="endDate"
              prepend-inner-icon="mdi-calendar-clock"
              append-inner-icon="mdi-menu-down"
              class="mx-5"
              style="height: 40px; min-width: 180px"
              label="To"
              hide-details
            />
          </template>
          <v-list class="pa-0" style="max-width: fit-content">
            <v-list-item class="pa-0">
              <v-list-item-title>
                <v-date-picker
                  v-model="endDate"
                  show-adjacent-months
                  :min="startDate"
                />
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        outlined
        dense
        hide-details
      ></v-text-field>
    </v-card-actions>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="15"
        dense
        :hide-default-footer="!!tenant_uid"
        :search="search"
      >
        <template v-slot:[`item.activated`]="{ item }">
          <v-icon v-if="!item.activated">mdi-close</v-icon>
          <span v-if="item.activated">{{ item.activated }}</span>
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ item?.code }} - {{ tenantName }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalise, formatDate, endOfDay } from "@/lib/utils";

const DAY_IN_MS = 24 * 60 * 60 * 1000;
const defaultStart = new Date(new Date().getTime() - 365 * DAY_IN_MS);
const defaultEnd = new Date();

export default {
  props: ["tenant_uid"],
  data: () => ({
    loading: false,
    detailsDialog: false,
    startDate: formatDate(defaultStart),
    endDate: formatDate(defaultEnd),
    item: null,
    search: null,
    headers: [
      { text: "Tenant", value: "tenant" },
      { text: "Plan Code", value: "code" },
      { text: "Status", value: "status" },
      { text: "Cycle", value: "cycle" },
      { text: "Activated", value: "activated" },
      { text: "Created", value: "created" },
      { text: "Details", value: "details" },
    ],
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },
  },

  computed: {
    ...mapGetters(["subscriptions", "tenants"]),
    items() {
      return this.subscriptions
        ?.filter((s) => !this.tenant_uid || s.tenant_uid === this.tenant_uid)
        .filter(
          (s) =>
            new Date(s.created_at) >= new Date(this.startDate) &&
            new Date(s.created_at) < endOfDay(this.endDate)
        )
        .map((s) => ({
          tenant: this.tenants?.find((t) => t.uid === s.tenant_uid)?.name,
          code: s.plan_code,
          status: capitalise(s.subscription_status),
          cycle: new Date(s.end_time).toLocaleDateString(),
          activated: s.activated_at
            ? new Date(s.activated_at).toLocaleDateString()
            : false,
          created: new Date(s.created_at).toLocaleDateString(),
          details: s,
        }));
    },
    tenantName() {
      if (!this.item) return;
      const tenant = this.tenants?.find(
        (t) => t.uid === this.item.details.tenant_uid
      );
      return tenant?.name;
    },
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    openDetail(item) {
      this.$router.push("/instances/" + item.details.uid);
    },
  },
};
</script>
